/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PendoModule } from '@fleetmatics/ui.insights';

import { NOTIFICATION_CLIENT_CONFIGS, NotificationsClientService } from '@fleetmatics/ui.notifications/client';
import { environment } from '../../environments/environment';
import { ExternalContainerComponent } from './components';
import {
  AgentCoreChatLoaderService,
  AmazonConnectChatLoaderService,
  LiveChatScriptLoaderService,
  PendoTrackEventService,
  WebsocketConnectorService
} from './services';

@NgModule({
  declarations: [ExternalContainerComponent],
  imports: [CommonModule, PendoModule.forRoot(environment.config)],
  providers: [
    { provide: NOTIFICATION_CLIENT_CONFIGS, useValue: environment.config },
    NotificationsClientService,
    WebsocketConnectorService,
    PendoTrackEventService,
    LiveChatScriptLoaderService,
    AmazonConnectChatLoaderService,
    AgentCoreChatLoaderService
  ],
  bootstrap: [ExternalContainerComponent]
})
export class ExternalModule {}
